import createDocumentData from "../../utils/createDocumentData";

import { Serie } from "./types/Serie";

export default function createSerieData(firebase, data) {
	return Serie.parse(createDocumentData(firebase, "series", data));
}
